import React from 'react';
import styled from 'styled-components';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { adminMenuList } from 'utils/constants/adminMenu';

const AdminLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    navigate('/admin/login');
  };

  return (
    <Container>
      <Sidebar>
        <Logo>Admin</Logo>
        <Nav>
          {adminMenuList.map((item) => (
            <NavItem
              key={item.link}
              isActive={location.pathname === item.link}
              onClick={() => navigate(item.link)}
            >
              {item.name}
            </NavItem>
          ))}
        </Nav>
        <LogoutButton onClick={handleLogout}>로그아웃</LogoutButton>
      </Sidebar>
      <Main>
        <Outlet />
      </Main>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  min-height: 100vh;
  background-color: #f4f7fe;
`;

const Sidebar = styled.div`
  width: 220px;
  background-color: #fff;
  border-right: 1px solid #e4e4e4;
  display: flex;
  flex-direction: column;
  padding: 24px 0;
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
`;

const Logo = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #644ded;
  padding: 0 24px 24px;
  border-bottom: 1px solid #e4e4e4;
`;

const Nav = styled.div`
  flex: 1;
  padding: 16px 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const NavItem = styled.div`
  font-size: 14px;
  font-weight: ${({ isActive }) => (isActive ? '700' : '500')};
  color: ${({ isActive }) => (isActive ? '#644ded' : '#4a5568')};
  padding: 10px 12px;
  border-radius: 8px;
  cursor: pointer;
  background-color: ${({ isActive }) => (isActive ? '#f0edff' : 'transparent')};
  transition: all 0.2s;

  &:hover {
    background-color: ${({ isActive }) => (isActive ? '#f0edff' : '#f7f7f7')};
    color: #644ded;
  }
`;

const LogoutButton = styled.div`
  font-size: 13px;
  color: #8f9bba;
  padding: 12px 24px;
  cursor: pointer;
  border-top: 1px solid #e4e4e4;

  &:hover {
    color: #e53e3e;
  }
`;

const Main = styled.div`
  flex: 1;
  margin-left: 220px;
  padding: 32px;
`;

export default React.memo(AdminLayout);
